<a id="logout" (click)="confirmLogout()">
  {{ 'Auth.Logout.Link' | translate }}
</a>
